'use strict';

Object.defineProperty(exports, "__esModule", {
	value: true
});

var _magicVirtualElement = require('magic-virtual-element');

var _magicVirtualElement2 = _interopRequireDefault(_magicVirtualElement);

var _createCmsComponent = require('../../utils/create-cms-component');

var _createCmsComponent2 = _interopRequireDefault(_createCmsComponent);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/** @jsx dom */
var render = function render(_ref) {
	var props = _ref.props;
	var html = props.html;


	return (0, _createCmsComponent2.default)((0, _magicVirtualElement2.default)('div', { 'class': ['CMS-Html', props.class], innerHTML: html }), props);
};

exports.default = { render: render };